import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Spin } from "antd";
import styles from "./ObservadorDetall.module.css";
import {
  getIdObservadorLlista,
  getDadesObservador,
  getPeticioEnCurs
} from "../../reducers";
import ObservadorFormulari from "./ObservadorFormulari";
import ObservadorRestablirContrasenyaFormulari from "./ObservadorRestablirContrasenyaFormulari";
import * as rutes from "../../routes";
import { obtenirDadesObservador } from "../../actions";
import { RETARD_MILISEGONS_APARICIO_SPINNER } from "../../constantsObservacions";
import { MISSATGE_SPIN_OBSERVADOR } from "../../constantsFormularis";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import { rutaObservadors, rutaEdicioObservador } from "../../routes";
import { NotificacioError, NotificacioWarning } from '../Notification';

class ObservadorDetall extends Component {

  gestioExit = (resposta, idObservador) => {

    if (resposta && resposta.error && resposta.error.message && resposta.error.titol) {
      NotificacioError(resposta.error.titol, resposta.error.message);
    }
    if (resposta && resposta.payload && resposta.payload[idObservador] && resposta.payload[idObservador].missatgeErrorFoto) {
      NotificacioWarning("Avís foto observador", resposta.payload[idObservador].missatgeErrorFoto);
    }
  };

  componentDidMount() {
    const { idObservador, peticioEnCurs } = this.props;
    if (!peticioEnCurs) {
      this.props.obtenirDadesObservador(idObservador).then(
        (dadesObservador) => {
          this.gestioExit(dadesObservador, idObservador);
        },
        (error) => {
          this.gestioExit(error);
        },
      );;
    }
  }

  generarBotoDonarDeBaixa() {
    return (
      <Link
        to={{
          pathname: rutes.rutaBaixaObservador,
          query: { render: false }
        }}
      >
        <Button size="large">Donar de baixa</Button>
      </Link>
    );
  }

  generarBotoDonarDeAlta() {
    const { idObservador } = this.props;
    return (
      <Link
        to={{
          pathname: rutes.rutaAltaObservador,
          query: { render: false, id: idObservador }
        }}
      >
        <Button size="large">Donar d'alta</Button>
      </Link>
    );
  }

  generarBotoRestablirContrasenya(idObservador) {
    return (
      <ObservadorRestablirContrasenyaFormulari idObservador={idObservador} />
    );
  }

  generarBotoEditar() {
    return (
      <Link
        to={{
          pathname: rutaEdicioObservador,
          query: { render: false }
        }}
      >
        <Button type="primary" size="large">
          Editar
        </Button>
      </Link>
    );
  }

  generarBotoTornar() {
    return (
      <Link
        className={styles.back}
        to={{
          pathname: rutaObservadors,
          query: { render: false }
        }}
      >
        <Button icon="left">Tornar</Button>
      </Link>
    );
  }

  render() {
    const { idObservador, dadesObservador, peticioEnCurs } = this.props;

    if (!dadesObservador) {
      return (
        <Spin
          spinning={true}
          delay={RETARD_MILISEGONS_APARICIO_SPINNER}
          tip={MISSATGE_SPIN_OBSERVADOR}
        />
      );
    }

    let botoAltaBaixaUsuari,
      botoRestablirContrasenya,
      botoEditar,
      botoTornar = null;

    const historic = Array.isArray(dadesObservador.historic)
      ? dadesObservador.historic[dadesObservador.historic.length - 1]
      : undefined;

    const usuariActiu = historic && historic.dataBaixa ? false : true;

    if (!peticioEnCurs) {
      botoAltaBaixaUsuari = usuariActiu
        ? this.generarBotoDonarDeBaixa()
        : this.generarBotoDonarDeAlta();

      botoRestablirContrasenya = this.generarBotoRestablirContrasenya(
        idObservador
      );
      botoEditar = this.generarBotoEditar();
      botoTornar = this.generarBotoTornar();
    }

    return (
      <Spin spinning={peticioEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER}>
        <div className={styles.observadorIntroduccioDetall}>
          <div className={styles.observadorIntroduccioDetallContenidor}>
            <ObservadorFormulari
              esEditable={false}
              dadesObservador={dadesObservador}
            />
          </div>
          <div className={styles.observadorIntroduccioDetallBotons}>
            {botoEditar}
            {botoRestablirContrasenya}
            {botoAltaBaixaUsuari}
          </div>
          <div className={styles.observadorIntroduccioDetallTornar}>
            {botoTornar}
          </div>
        </div>
      </Spin>
    );
  }
}

ObservadorDetall.propTypes = {
  idObservador: PropTypes.number,
  obtenirDadesObservador: PropTypes.func.isRequired,
  dadesObservador: PropTypes.object,
  peticioEnCurs: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    idObservador: getIdObservadorLlista(state),
    dadesObservador: getDadesObservador(state),
    peticioEnCurs: getPeticioEnCurs(state)
  };
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, { obtenirDadesObservador })(ObservadorDetall)
);
